
const placeholderPattern = new RegExp('\\{([^}]+)\\}');

const validFormatPattern = /^(\{([^}]+)\}\|){0,1}\{([^}]+)\}(,? \{([^}]+)\})*$/;

export default function AddressFormatter (format) {
    if (!validFormatPattern.test(format)) throw new Error(`Invalid format: ${format}`);
    this._format = format;
}


AddressFormatter.prototype.format = function (location) {
    const sections = this._format.split(/, */);
    return sections
        .map(s => this.replacePlaceholders(s, location).trim())
        .map(s => s.replace('|', '/'))
        .filter(s => s && s.length > 0)
        .join(', ');
};


AddressFormatter.prototype.replacePlaceholders = function (fragment, location) {
    var formatted = fragment;

    var match = placeholderPattern.exec(formatted);
    while (match != null) {
        const placeholder = match[0];
        const name = match[1];
        formatted = formatted.replace(placeholder, location[name] || '');
        //Remove any separators at the start of a fragment
        if (formatted.substring(0, 1) === '|') {
            formatted = formatted.substring(1);
        }
        match = placeholderPattern.exec(formatted);
    }

    return formatted;
};
